// Must run first: the Trusted Types policy has to exist before the realm worker is created.
import './security/trustedTypes.ts';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerServiceWorker } from './offline/registerServiceWorker.ts';
import { router } from './router.tsx';
import { applyAppearance } from './settings.ts';
import { listenForShortcuts } from './shortcuts.ts';
import './styles.css';

registerServiceWorker();
// The skin and text size from Settings, before anything is drawn.
applyAppearance();
listenForShortcuts();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
